// CircleSlideshow.js
import { useState, useEffect, useRef } from 'react';

const CircleSlideshow = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [previousIndex, setPreviousIndex] = useState(null);
  const intervalRef = useRef(null);

  // Function to show next slide
  const nextSlide = useRef(() => {});

  nextSlide.current = () => {
    setPreviousIndex(currentIndex);
    setCurrentIndex((prevIndex) => (prevIndex + 1) % slides.length);
  };

  // Set up and clean up the interval
  useEffect(() => {
    intervalRef.current = setInterval(() => {
      nextSlide.current();
    }, 5000);
    
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [slides.length, currentIndex]);

  // Handle dot click
  const handleDotClick = (index) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    
    setPreviousIndex(currentIndex);
    setCurrentIndex(index);
    
    intervalRef.current = setInterval(nextSlide, 1000);
  };

  return (
    <div className="slideshow-container">
      <div className="circle-stage">
        {slides.map((slide, index) => (
          <div 
            key={`circle-${index}`}
            className={`circle-container ${index === currentIndex ? 'active' : ''} ${index === previousIndex ? 'exit' : ''}`}
            id={`circle-${index + 1}`}
          >
            <div className="main-circle">{slide}</div>
          </div>
        ))}
      </div>

      <div className="progress-container">
        {slides.map((_, index) => (
          <div 
            key={`dot-${index}`}
            className={`progress-dot ${index === currentIndex ? 'active' : ''}`}
            id={`dot-${index + 1}`}
            onClick={() => handleDotClick(index)}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default CircleSlideshow;